module.exports = __webpack_public_path__ + "images/花筑村全景_05.jpg?v=8a751066";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu5/花筑村全景_05.jpg
 ** module id = 92
 ** module chunks = 1 2
 **/